module.exports = __webpack_public_path__ + "static/media/PT.e7fe13fe.png";